<template>
  <v-app>
    <v-toolbar
      :class="{'home-page': splashscreen}"
      fixed
      scroll-off-screen
      class="elevation-0"
      @click="splashscreen = false"
      style="background-color: rgba(0, 0, 0, 0);"
    >
      <v-toolbar-side-icon
        class="hidden-md-and-up white--text"
        v-if="!splashscreen"
        @click="drawer = !drawer"
      ></v-toolbar-side-icon>
      <v-toolbar-title
        :class="{'title-center': splashscreen}"
        style="margin-left:42px;font-family: secondary;"
      >
        <div></div>
        <v-img
          v-if="splashscreen"
          :src="photoBiography"
          :lazy-src="photoBiography"
          style="border-radius:50%; width: 150px; height:150px; border:solid 6px white; margin-right:auto;margin-left:auto"
          class="mb-4"
        >
          <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-layout>
        </v-img>
        <div
          @click="$router.push('/')"
          style="cursor:pointer;font-family: secondary;line-height:40px;padding-left:5px; font-size:30px;user-select: none;"
        >{{ title }}</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" v-if="!splashscreen">
        <div v-for="view in views" style="height:100%;display:flex" :key="view.title">
          <v-btn
            class="white--text font-weight-light"
            v-if="view.to && view.title != 'Accueil' && view.title != 'Admin'"
            @click="$router.push(view.to)"
            flat
          >{{view.title}}</v-btn>
          <v-btn
            v-if="view.href && !user && !userBuffer"
            left
            color="secondary primary--text"
            round
            class="elevation-0 justify-center font-weight-light"
            style="height:32px;"
            :href="view.href"
          >
            {{view.title}}
            <v-icon dark small right>mail</v-icon>
          </v-btn>
          <v-btn
            v-if="view.title == 'Mode admin' || view.title == 'Mode visiteur' "
            left
            color="secondary primary--text"
            round
            class="elevation-0 justify-center font-weight-light"
            :class="{'success secondary--text': view.title == 'Mode admin'}"
            style="height:32px;"
            @click="switchMode()"
          >
            {{view.title}}
            <v-icon size="18" dark right v-if="view.title == 'Mode visiteur'">visibility</v-icon>
            <v-icon size="18" dark right v-if="view.title == 'Mode admin'">create</v-icon>
          </v-btn>
        </div>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down" v-if="!splashscreen">
        <div
          v-for="socialMedia in socialMedias"
          :key="socialMedia.title"
          style="height:100%;display:flex"
        >
          <v-btn class="zoom" target="_blank" :href="socialMedia.to" flat fab>
            <div :class="socialMedia.title"></div>
          </v-btn>
        </div>
      </v-toolbar-items>
      <v-btn
        class="zoom"
        flat
        fab
        v-if="fromMobile && !user && !splashscreen && browser != 'ios'"
        @click="share()"
      >
        <v-icon class="secondary--text">share</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      width="160"
      v-model="drawer"
      absolute
      temporary
      dark
      touchless
      style="position:fixed; top:0; left:0;"
    >
      <v-list class="pt-0 pb-0">
        <v-list-tile
          v-for="view in views"
          :key="view.title"
          @click="view.to?$router.push(view.to):(view.href?null:switchMode())"
          :href="!view.to?view.href:null"
          :class="{ selected: $router.currentRoute.path == view.to }"
          class="drawer-text"
        >
          <v-list-tile-content>
            <v-list-tile-title
              :class="{'switch-button-admin': view.title == 'Mode admin', 'switch-button-visitor': view.title == 'Mode visiteur'}"
            >
              {{ view.title }}
              <v-icon
                style="margin-bottom:6px"
                small
                dark
                v-if="view.title == 'Mode visiteur'"
              >visibility</v-icon>
              <v-icon style="margin-bottom:6px" small dark v-if="view.title == 'Mode admin'">create</v-icon>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <!-- <v-list class="pt-0" three-line>
        <v-list-tile>
          <v-list-tile-content v-for="socialMedia in socialMedias" :key="socialMedia.title">
            <v-btn class="zoom" target="_blank" :href="socialMedia.to" flat fab>
              <div :class="socialMedia.title"></div>
            </v-btn>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>-->
      <v-layout align-center justify-center column class="mt-3">
        <v-flex v-for="socialMedia in socialMedias" :key="socialMedia.title">
          <v-btn class="zoom" target="_blank" :href="socialMedia.to" flat fab>
            <div :class="socialMedia.title"></div>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>

    <v-content class="background-texture">
      <transition name="slide-fade">
        <keep-alive>
          <router-view style="margin-top:60px;"/>
        </keep-alive>
      </transition>
    </v-content>
    <DialogItem/>
    <DialogLogin :title="title"/>
    <Footer :socialMedias="socialMedias"/>
    <Snackbar/>
    <div v-if="user && !splashscreen">
      <div class="administrator-mode administrator-mode-top"></div>
      <div class="administrator-mode administrator-mode-right"></div>
      <div class="administrator-mode administrator-mode-bottom"></div>
      <div class="administrator-mode administrator-mode-left"></div>
    </div>
  </v-app>
</template>

<script>
import photoBiography from "./assets/photo-bio.jpg";
import DialogItem from "./components/DialogItem";
import DialogLogin from "./components/DialogLogin";
import Footer from "./components/Footer";
import Snackbar from "./components/Snackbar";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    Footer,
    DialogItem,
    DialogLogin,
    Snackbar
  },
  mounted() {
    let self = this;
    setTimeout(function() {
      self.splashscreen = false;
    }, 3000);
    this.$store.dispatch("getAll");
  },
  methods: {
    switchMode() {
      this.drawer = false;
      this.$store.commit("setSwitchMode");
    },
    share() {
      if (navigator.share && this.fromMobile) {
        navigator
          .share({
            title: "Sylvain Becquart Artiste Peintre",
            text: "Sylvain Becquart Artiste Peintre",
            url: "https://syl-vain.firebaseapp.com"
          })
          .then(() => console.log("Share complete"));
      }
    }
  },
  computed: {
    ...mapState([
      "huiles",
      "dessins",
      "atelier",
      "user",
      "userBuffer",
      "browser",
      "title"
    ]),
    fromMobile() {
      return navigator.userAgent.indexOf("Mobile") !== -1;
    },
    views() {
      let views = [];
      views.push({ title: "Accueil", to: "/" });
      if (this.huiles.length > 0 || this.user)
        views.push({ title: "Huiles", to: "/huiles" });
      if (this.dessins.length > 0 || this.user)
        views.push({ title: "Dessins", to: "/dessins" });
      views.push({ title: "Biographie", to: "/biographie" });
      if (this.atelier.length > 0 || this.user)
        views.push({ title: "Atelier", to: "/atelier" });
      if (!this.user && !this.userBuffer && this.browser != "ios") {
        views.push({
          title: "Contact",
          href: "mailto:becquartsf@gmail.com?Subject=syl-vain.fr%20-%20Question"
        });
      } else if (this.user && !this.userBuffer) {
        views.push({
          title: "Mode admin"
        });
      } else if (!this.user && this.userBuffer) {
        views.push({
          title: "Mode visiteur"
        });
      }
      return views;
    }
  },
  data() {
    return {
      drawer: null,
      splashscreen: true,
      photoBiography: photoBiography,
      // views: [
      //   { category: undefined, title: "Accueil", to: "/" },
      //   { category: this.huiles, title: "Huiles", to: "/huiles" },
      //   { category: this.dessins, title: "Dessins", to: "/dessins" },
      //   { category: undefined, title: "Biographie", to: "/biographie" },
      //   { category: this.atelier, title: "Atelier", to: "/atelier" },
      //   {
      //     title: "Contact",
      //     href:
      //       "mailto:becquartsf@gmail.com?Subject=syl-vain.fr%20-%20Question"
      //   }
      // ],
      socialMedias: [
        {
          title: "instagram",
          to: "https://www.instagram.com/carnetdebalades/"
        },
        { title: "facebook", to: "https://www.facebook.com/becquart.sylvain/" },
        {
          title: "youtube",
          to: "https://www.youtube.com/user/sbecquartpeintures/videos"
        }
      ]
    };
  }
};
</script>

<style>
.v-dialog {
  box-shadow: none !important;
}
@font-face {
  font-family: secondary;
  src: url(./assets/samantha.ttf);
}
.drawer-text div {
  font-family: secondary;
  font-size: 20px !important;
}
.selected {
  background-color: rgba(255, 255, 255, 0.2);
}
.background-texture {
  background: url("./assets/background-texture.png") repeat;
}
.youtube {
  background: url("./assets/socials.png") no-repeat -192px -3px;
  width: 33px;
  height: 32px;
}
.zoom > div {
  transform: scale(0.9);
}
.zoom:hover > div {
  transform: scale(1);
  transition: all 0.5s;
}
.facebook {
  background: url("./assets/socials.png") no-repeat -117px -2px;
  width: 33px;
  height: 33px;
}
.instagram {
  background: url("./assets/socials.png") no-repeat -41px -3px;
  width: 32px;
  height: 32px;
}

/* width */
::-webkit-scrollbar {
  width: 0px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.8);
}

.slide-fade-enter-active {
  transition: all 0.8s ease-out;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
}

.v-toolbar__content {
  background-color: rgba(0, 0, 0, 0.8);
  transition: all 0.3s;
  color: white;
}
.v-toolbar__title {
  font-size: 30px;
}
.home-page .v-toolbar__content {
  background-color: rgba(0, 0, 0, 1);
  height: 100vh !important;
}
.home-page .title-center {
  width: 100%;
  margin-left: 0px !important;
  text-align: center;
  font-size: 40px;
  /* text-shadow: 0px 5px 15px rgba(0,0,0,0.6); */
  padding-bottom: 50px;
}

.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
  padding-bottom: 30px;
}

.rotate-90 > .v-image__image {
  transform: rotate(90deg);
}
.rotate-180 > .v-image__image {
  transform: rotate(180deg);
}
.rotate-270 > .v-image__image {
  transform: rotate(270deg);
}
.v-image__image {
  transition: all 0.5s;
}

.switch-button-admin {
  color: white;
  background-color: #4caf50;
  border-radius: 15px;
  height: 30px;
  padding-left: 15px !important;
  padding-top: 5px;
}
.switch-button-visitor {
  color: black;
  background-color: white;
  border-radius: 15px;
  height: 30px;
  padding-left: 15px !important;
  padding-top: 5px;
}

.administrator-mode {
  position: fixed;
  background-color: #4caf50;
  z-index: 30;
}
.administrator-mode-top {
  height: 4px;
  top: 0;
  right: 0;
  left: 0;
}
.administrator-mode-right {
  width: 4px;
  top: 0;
  right: 0;
  bottom: 0;
}
.administrator-mode-bottom {
  height: 4px;
  right: 0;
  bottom: 0;
  left: 0;
}
.administrator-mode-left {
  width: 4px;
  top: 0;
  bottom: 0;
  left: 0;
}

.v-dialog {
  margin: 0px;
}
</style>